<template>
  <div v-if="!isManager" class="callback page-container">
    <div class="callback__wrap">
      <div class="callback__block">
        <h2 class="callback__title">{{ $t('footer.have.questions') }}</h2>
        <p class="callback__text">{{ $t('footer.leave.phone') }}</p>
      </div>
      <div class="callback__block">
        <ProductCallbackForm />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductCallbackForm from './ProductCallbackForm'

export default {
  name: 'ProductCallback',
  components: {
    ProductCallbackForm
  },
  computed: {
    ...mapGetters(['isManager'])
  }
}
</script>

<style scoped lang="sass">

.callback
  margin-top: 150px

.callback__wrap
  display: flex
  position: relative
  flex-direction: column
  text-align: center
  padding: 40px 30px
  background-color: $text-color
  border-radius: 10px
  justify-content: space-between
  align-items: center

  +mmin($tablet)
    flex-direction: row
    text-align: left
    padding: 30px 30px 30px 200px

  +mmin(1365)
    padding: 30px 100px 30px 270px

  &:before
    display: none
    position: absolute
    left: 50%
    top: 0
    transform: translate(-50%, -31%)
    content: ''
    width: 160px
    height: 160px
    background: url('/img/svgo/product-page/callback.svg') no-repeat center
    background-size: cover

    +mmin($tablet)
      display: block
      left: 0
      transform: translate(20px, -31%)

    +mmin(1365)
      transform: translate(35%, -31%)

.callback__title
  font-weight: 400
  font-size: 18px
  letter-spacing: 0.04em
  line-height: 23px
  color: $white-text-color
  text-transform: uppercase
  margin: 0

.callback__text
  font-weight: 400
  font-size: 14px
  line-height: 18px
  max-width: 400px
  color: #c4c4c4
  margin: 20px auto 0

  +mmin($tablet)
    margin: 18px 0 0

.callback__block
  width: 100%

  &:last-child
    margin-top: 40px

  +mmin($tablet)
    width: 50%

    &:last-child
      width: 50%
      margin-top: 0
      margin-left: 30px

  +mmin($tablet--hor)
    width: 40%

    &:last-child
      width: 70%

.callback__form
  display: flex
  flex-direction: column

  +mmin($tablet--hor)
    justify-content: flex-end
    flex-direction: row
</style>
